/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */
import * as React from "react"
import UniversalLink from "§/src/utils/UniversalLink"

const BaseMenu = ( props ) => {

  const menu = props.wpMenu.nodes;
  const className = props.className;
  const buttonClass = props.buttonClass;
  const id = props.id;

  return (

    <div id={ id } className={ 'base-menu ' + className }>
      {menu.map((menuItem, index) => {

				return(
          <UniversalLink
            className={ buttonClass }
            to={ menuItem.uri }
            activeClassName="active"
            key={ index }
						target={menuItem.target || '_self'}
          >
            {menuItem.title}
          </UniversalLink>
        )

      })}
    </div>

  )
}

export default BaseMenu
